import React from 'react';
import PropTypes from 'prop-types';
import ErrorComponent from '../components/Error';

export default function Error({ statusCode, err }) {
  const pageNotFound = statusCode === 404;

  const heading = pageNotFound ? 'Page not found' : 'We need a moment';
  const description = pageNotFound ? (
    <>
      Return to our <a href="https://education.com/">homepage</a>
    </>
  ) : (
    <>Our servers experienced an unexpected error</>
  );
  return (
    <ErrorComponent err={err} heading={heading} description={description} />
  );
}

Error.displayName = 'Error';
Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode, err };
};

Error.propTypes = {
  statusCode: PropTypes.any,
  err: PropTypes.any,
};
